import React, { useState } from 'react';

const approaches = [
  {
    iconColor: '#E8611A',
    iconBg: 'rgba(232,97,26,0.15)',
    icon: (
      <svg width="28" height="28" fill="none" stroke="#E8611A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
        <path d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
      </svg>
    ),
    title: 'Méthodologie',
    description: "Notre approche structurée maximise la transparence des budgets et des délais, en gardant toujours l'objectif final au cœur de nos préoccupations.",
    link: '/etude-conseil',
  },
  {
    iconColor: '#a78bfa',
    iconBg: 'rgba(167,139,250,0.15)',
    icon: (
      <svg width="28" height="28" fill="none" stroke="#a78bfa" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
        <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
      </svg>
    ),
    title: 'Innovation Constante',
    description: "Nous explorons et intégrons continuellement de nouvelles technologies pour rester à la pointe de l'innovation et offrir les meilleures solutions.",
    link: '/services',
  },
  {
    iconColor: '#16a34a',
    iconBg: 'rgba(22,163,74,0.15)',
    icon: (
      <svg width="28" height="28" fill="none" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
        <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    title: "Esprit d'Équipe",
    description: "L'agilité et l'expertise de notre équipe nous permettent de gérer les projets avec une complémentarité parfaite et une efficacité maximale.",
    link: '/notre-equipe',
  },
  {
    iconColor: '#38bdf8',
    iconBg: 'rgba(56,189,248,0.15)',
    icon: (
      <svg width="28" height="28" fill="none" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
        <path d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
      </svg>
    ),
    title: 'Notre Engagement',
    description: "Nous développons des solutions robustes et évolutives qui répondent aux plus hautes exigences de sécurité et de performance.",
    link: '/services',
  },
];

const technologies = [
  { name: 'React',     color: '#61dafb', icon: <svg viewBox="0 0 24 24" width="36" height="36" fill="#61dafb"><circle cx="12" cy="12" r="2.5"/><ellipse cx="12" cy="12" rx="10" ry="4" fill="none" stroke="#61dafb" strokeWidth="1.2"/><ellipse cx="12" cy="12" rx="10" ry="4" fill="none" stroke="#61dafb" strokeWidth="1.2" transform="rotate(60 12 12)"/><ellipse cx="12" cy="12" rx="10" ry="4" fill="none" stroke="#61dafb" strokeWidth="1.2" transform="rotate(120 12 12)"/></svg> },
  { name: 'Next.js',   color: '#ffffff', icon: <svg viewBox="0 0 180 180" width="36" height="36"><mask id="nxt-m" maskUnits="userSpaceOnUse" x="0" y="0" width="180" height="180"><circle cx="90" cy="90" r="90" fill="white"/></mask><g mask="url(#nxt-m)"><circle cx="90" cy="90" r="90" fill="black"/><path d="M149.508 157.52L69.142 54H54v71.97h11.378V69.384l72.328 95.461a90.21 90.21 0 0011.802-7.325z" fill="white"/><rect x="115" y="54" width="11" height="72" fill="white"/></g></svg> },
  { name: 'Python',    color: '#3776ab', icon: <svg viewBox="0 0 24 24" width="36" height="36"><path fill="#3776ab" d="M11.914 0C5.82 0 6.2 2.656 6.2 2.656l.007 2.752h5.814v.826H3.9S0 5.789 0 11.969c0 6.18 3.403 5.963 3.403 5.963h2.03v-2.868s-.109-3.403 3.35-3.403h5.769s3.24.052 3.24-3.13V3.26S18.28 0 11.914 0zM8.708 1.882a1.049 1.049 0 11-.001 2.099 1.049 1.049 0 010-2.099z"/><path fill="#ffd43b" d="M12.086 24c6.094 0 5.714-2.656 5.714-2.656l-.007-2.752h-5.814v-.826H20.1S24 18.211 24 12.031c0-6.18-3.403-5.963-3.403-5.963h-2.03v2.868s.109 3.403-3.35 3.403H9.448s-3.24-.052-3.24 3.13V20.74S5.72 24 12.086 24zm3.206-1.882a1.049 1.049 0 110-2.098 1.049 1.049 0 010 2.098z"/></svg> },
  { name: 'PHP',       color: '#8892be', icon: <svg viewBox="0 0 128 128" width="38" height="38"><ellipse cx="64" cy="64" rx="64" ry="33.5" fill="#6181b6"/><ellipse cx="64" cy="64" rx="64" ry="33.5" fill="url(#php-g)"/><defs><radialGradient id="php-g" cx="30%" cy="30%" r="70%"><stop offset="0%" stopColor="#9aadce"/><stop offset="100%" stopColor="#4a6491"/></radialGradient></defs><text x="64" y="71" textAnchor="middle" fontFamily="DejaVu Sans,Arial,sans-serif" fontWeight="bold" fontSize="28" fill="white" letterSpacing="1">php</text></svg> },
  { name: 'Kotlin',    color: '#7F52FF', icon: <svg viewBox="0 0 24 24" width="36" height="36"><path fill="#7F52FF" d="M24 24H0V0h24L12 12z"/></svg> },
  { name: 'GraphQL',   color: '#e535ab', icon: <svg viewBox="0 0 24 24" width="36" height="36" fill="#e535ab"><path d="M12 2l10.39 6v12L12 22 1.61 20V8zm0 2.32L3.5 9.26v9.48L12 21.68l8.5-2.94V9.26zM12 6.5a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm0 2a3.5 3.5 0 100 7 3.5 3.5 0 000-7z"/></svg> },
  { name: 'Firebase',  color: '#FFCA28', icon: <svg viewBox="0 0 24 24" width="36" height="36"><path fill="#FFCA28" d="M3.89 15.672L6.255.461A.542.542 0 017.27.288l2.543 4.771zm16.794 3.692l-2.25-14a.54.54 0 00-.919-.295L3.316 19.365l7.856 4.427a1.621 1.621 0 001.588 0zM14.3 7.147l-1.82-3.482a.542.542 0 00-.96 0L3.53 17.984z"/></svg> },
  { name: 'Hasura',    color: '#1EB4D4', icon: <svg viewBox="0 0 24 24" width="36" height="36" fill="#1EB4D4"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg> },
  { name: 'WordPress', color: '#21759b', icon: <svg viewBox="0 0 24 24" width="36" height="36"><circle cx="12" cy="12" r="10" fill="#21759b"/><path fill="#fff" d="M2.05 12A9.95 9.95 0 0012 21.95 9.95 9.95 0 0021.95 12 9.95 9.95 0 0012 2.05 9.95 9.95 0 002.05 12zm1.5 0a8.45 8.45 0 018.45-8.45 8.45 8.45 0 018.45 8.45 8.45 8.45 0 01-8.45 8.45A8.45 8.45 0 013.55 12zm3.6-5.25l3.5 9.3 2.1-5.6 2.1 5.6 3.5-9.3a7.1 7.1 0 01.55 2.75 7.1 7.1 0 01-7.1 7.1 7.1 7.1 0 01-7.1-7.1 7.1 7.1 0 01.45-2.75zM12 5.3a6.65 6.65 0 013.3.87l-3.3 9-3.3-9A6.65 6.65 0 0112 5.3z"/></svg> },
  { name: 'Drupal',    color: '#0678BE', icon: <svg viewBox="0 0 24 24" width="36" height="36"><path fill="#0678BE" d="M15.78 4.15C14.08 2.65 12.26 1.09 12 0c-.27 1.09-2.09 2.65-3.78 4.15C6.2 5.77 4 7.36 4 10.2a8 8 0 0016 0c0-2.84-2.2-4.43-4.22-6.05zM12 16.75A4.55 4.55 0 017.45 12.2c0-1.87.97-3.1 2.1-4.12a8.53 8.53 0 001.35-1.42c.28.44.75.95 1.35 1.42 1.13 1.02 2.1 2.25 2.1 4.12A4.55 4.55 0 0112 16.75z"/></svg> },
  { name: 'Django',    color: '#44b78b', icon: <svg viewBox="0 0 24 24" width="36" height="36" fill="#44b78b"><path d="M11.45 0h2.11v13.18c-1.08.21-1.88.29-2.74.29-2.58 0-3.93-1.17-3.93-3.4 0-2.15 1.44-3.55 3.67-3.55.34 0 .6.03 1 .12V0zm0 8.44c-.27-.1-.5-.13-.74-.13-1.08 0-1.7.67-1.7 1.84 0 1.14.59 1.77 1.67 1.77.24 0 .44-.02.77-.08V8.44zM15.08 6.57h2.1v7.31c0 2.52-.18 3.73-.72 4.77-.5.99-1.16 1.61-2.53 2.3l-1.86-.89c1.36-.64 2.02-1.2 2.43-2.07.44-.91.58-1.94.58-4.66V6.57z"/></svg> },
  { name: 'Laravel',   color: '#FF2D20', icon: <svg viewBox="0 0 50 52" width="36" height="36"><path fill="#FF2D20" d="M49.626 11.564a.809.809 0 01.028.209v10.972a.8.8 0 01-.402.694l-9.209 5.302-.032.018v10.509a.8.8 0 01-.402.694L20.042 51.24a.827.827 0 01-.095.046.786.786 0 01-.198.053L19.69 51.35a.826.826 0 01-.158-.048l-9.291-5.302a.8.8 0 01-.403-.694V6.891a.81.81 0 01.031-.212.716.716 0 01.031-.158.789.789 0 01.164-.215l.013-.015a.795.795 0 01.182-.126L19.53.217a.8.8 0 01.8 0l9.256 5.302a.802.802 0 01.4.694v10.513l7.97-4.604a.803.803 0 01.8 0l9.256 5.302a.8.8 0 01.213.14zM28.75 8.008L21.003 3.55 13.27 8.003l7.737 4.455 7.743-4.45zm-8.057 28.5l16.377-9.448V8.862l-7.929 4.577v9.447a.8.8 0 01-.4.694l-8.048 4.638v10.29zm-9.6-5.498l7.997 4.57V25.082l-7.997-4.57v10.498zm17.6-12.652l-7.6-4.38-7.6 4.38 7.6 4.373 7.6-4.373z"/></svg> },
];

function Card({ item }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: hovered ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.7)',
        backdropFilter: 'blur(12px)',
        border: hovered ? `1px solid ${item.iconColor}40` : '1px solid rgba(0,0,0,0.06)',
        borderRadius: 20,
        padding: '28px 24px',
        display: 'flex',
        flexDirection: 'column',
        gap: 14,
        cursor: 'default',
        transition: 'background .25s, border-color .25s, transform .25s, box-shadow .25s',
        transform: hovered ? 'translateY(-5px) scale(1.01)' : 'none',
        boxShadow: hovered ? `0 20px 40px rgba(0,0,0,0.12), 0 0 0 1px ${item.iconColor}20` : '0 4px 16px rgba(0,0,0,0.06)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {hovered && (
        <div style={{
          position: 'absolute', top: 0, left: 0, right: 0, height: 3,
          background: `linear-gradient(90deg, transparent, ${item.iconColor}, transparent)`,
          borderRadius: '20px 20px 0 0',
        }} />
      )}
      <div style={{
        width: 56, height: 56, borderRadius: 16,
        background: item.iconBg,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0,
        boxShadow: `0 4px 14px ${item.iconColor}25`,
      }}>
        {item.icon}
      </div>
      <h3 style={{ fontSize: '1.05rem', fontWeight: 700, color: '#1e293b', margin: 0 }}>
        {item.title}
      </h3>
      <p style={{ fontSize: '0.875rem', color: '#64748b', lineHeight: 1.7, margin: 0, flex: 1 }}>
        {item.description}
      </p>
      <a href={item.link} style={{
        display: 'inline-flex', alignItems: 'center', gap: 6,
        fontSize: '0.82rem', fontWeight: 600,
        color: item.iconColor, textDecoration: 'none',
        marginTop: 4,
      }}>
        En savoir plus
        <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
      </a>
    </div>
  );
}

const DigitalApproach = () => {
  return (
    <section style={{
      background: '#F8F7F4',
      padding: '36px 0 32px',
      position: 'relative',
      overflow: 'hidden',
      fontFamily: "'DM Sans', sans-serif",
      borderBottom: '1px solid rgba(0,0,0,0.07)',
    }}>


      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px', position: 'relative', zIndex: 1 }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            padding: '6px 18px', borderRadius: 999,
            border: '1px solid rgba(0,0,0,0.1)',
            background: 'rgba(0,0,0,0.04)',
            marginBottom: 14,
          }}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="#94a3b8"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
            <span style={{ fontSize: '0.72rem', fontWeight: 700, color: '#64748b', letterSpacing: '0.1em', textTransform: 'uppercase' }}>Innovation & Excellence</span>
          </div>

          <h2 style={{ fontSize: 'clamp(1.6rem, 3vw, 2.2rem)', fontWeight: 800, color: '#1e293b', margin: '0 0 10px', lineHeight: 1.2 }}>
            Notre approche digitale chez{' '}
            <span style={{ background: 'linear-gradient(to right, #E8611A, #d4501a)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Aydees</span>
          </h2>
          <div style={{ width: 40, height: 3, background: 'linear-gradient(90deg, #E8611A, #16a34a)', borderRadius: 4, margin: '0 auto 14px' }} />
          <p style={{ color: '#64748b', maxWidth: 600, margin: '0 auto', fontSize: '0.9rem', lineHeight: 1.7 }}>
            Nous utilisons des technologies performantes comme JavaScript, Next.js, PHP, Kotlin, Python,
            GraphQL, Firebase, Hasura. Nos process de déploiement et d'intégration sont optimisés pour
            accélérer les développements.
          </p>
        </div>

        {/* Cards */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          gap: 16,
          marginBottom: 20,
        }}>
          {approaches.map((item, i) => <Card key={i} item={item} />)}
        </div>

        {/* Tech divider */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24 }}>
          <div style={{ flex: 1, height: 1, background: 'rgba(0,0,0,0.08)' }} />
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="#94a3b8"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
            <span style={{ fontSize: '0.68rem', fontWeight: 700, color: '#94a3b8', letterSpacing: '0.12em', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>Nos technologies principales</span>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="#94a3b8"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
          </div>
          <div style={{ flex: 1, height: 1, background: 'rgba(0,0,0,0.08)' }} />
        </div>

        {/* Tech row */}
        <div style={{ display: 'flex', flexWrap: 'nowrap', overflowX: 'auto', gap: 10, paddingBottom: 6, scrollbarWidth: 'none', msOverflowStyle: 'none', justifyContent: 'center' }}>
          {technologies.map((tech) => (
            <div key={tech.name} style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6,
              padding: '12px 14px', borderRadius: 12,
              background: 'rgba(255,255,255,0.8)',
              border: '1px solid rgba(0,0,0,0.06)',
              boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
              minWidth: 72, flexShrink: 0,
              transition: 'background .2s, border-color .2s, transform .2s, box-shadow .2s',
              cursor: 'default',
            }}
            onMouseEnter={e => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.borderColor = `${tech.color}50`; e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = `0 8px 20px rgba(0,0,0,0.1), 0 0 0 1px ${tech.color}20`; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.8)'; e.currentTarget.style.borderColor = 'rgba(0,0,0,0.06)'; e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)'; }}
            >
              {tech.icon}
              <span style={{ fontSize: '0.75rem', color: '#64748b', fontWeight: 600 }}>{tech.name}</span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default DigitalApproach;
